const posts = [
  {
    id:1,
    imageSrc:
      "https://res.cloudinary.com/dptdrzycj/image/upload/v1704289667/Screenshot_2024-01-03_191715_rbgyu9.png",
    title: "What is Public key cryptography ? ",
    description: "Awesome day at the beach! 🏖️ #SunsetVibes",
    link: "https://www.instagram.com/p/C1l7h9GpOgv/?utm_source=ig_web_copy_link",
  },
];

export default posts;
